import styled from 'styled-components';
import theme from 'src/theme';

export interface IButtonProps {
    onClick?: (filterEventsItemId: number) => void;
}

export const LowerWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 55px;
    z-index: 1;
    width: 200px;
    background: #fff;
    box-shadow: 0 3px 15px -2px #bbb;
    border: 1px solid #ddd;
`;

export const RotationInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const RotationInfoPanelWrapper = styled.div`
    flex: 0 0 auto;
    max-width: 30%;
    position: relative;
`;

export const PanelWrapper = styled.div`
    top: 60px;
    left: -265px;
    position: absolute;
    z-index: 2;
    width: 600px;
    background: #fff;
    box-shadow: #ccc 0px 2px 6px 2px;
    border: 1px solid #ddd;
    height: 200px;
    overflow-y: auto;

    &.is-selected {
        background: ${theme.legacyColors.selectedBackground};
        color: ${theme.legacyColors.selectedColor};
        border: 1px solid ${theme.legacyColors.selectedBorder};
        h5 {
            color: #fff;
        }
    }
    text {
        font-size: 0.9rem;
        font-weight: 500;
        height: 30px;
        padding: 10px;
    }
    h4 {
        font-size: 0.9rem;
        font-weight: 500;
        color: #fff;
        height: 40px;
        padding: 10px;
        border-bottom: 1px solid #ddd;
        button {
            margin: 0 5px;
        }
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    font-weight: 500;
    height: 40px;
    padding: 10px;
`;
